module.exports = __webpack_public_path__ + "5617f8cf0c0c9190a003297e4e64bc4a.png";